import React from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import { Row, Col, 
    Button 
} from "antd";
import { UnderwritingRequests, LedgerAnalysis } from "templates";

class UnderwritingView extends React.Component {
    render() {
        return (
            <Row className={"p-5 h-100"}>
                <Col span={24} className={"mb-10"}>
                    <Button icon={"arrow-left"} 
                        onClick={() => this.props.history.goBack()}
                    >{"Back"}</Button>
                </Col>
                <Switch>
                    <Route
                        exact
                        key={"job"}
                        path={"/app/underwriting/jobs/:id"}
                        render={props => (
                            <Col span={24} className={"p-5"}>
                                <LedgerAnalysis {...props} />
                            </Col>
                        )}
                    />
                    <Route
                        exact
                        key={"job-list"}
                        path={"/app/underwriting/jobs"}
                        render={props => (
                            <Col span={24} className={"p-5"}>
                                <UnderwritingRequests {...props} />
                            </Col>
                        )}
                    />
                    
                </Switch>
            </Row>
        );
    }
}

UnderwritingView.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object
};

export default UnderwritingView;
